import { QueryClient } from '@tanstack/react-query';

const reactQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Disable automatic refetch on window focus to prevent request storms after inactivity
      // The Axios interceptor will handle token refresh automatically on 401 errors
      refetchOnWindowFocus: false,
      
      // Keep data fresh for 5 minutes
      staleTime: 5 * 60 * 1000, // 5 minutes
      
      // Cache data for 30 minutes
      cacheTime: 30 * 60 * 1000, // 30 minutes
      
      // Retry failed requests with exponential backoff
      retry: (failureCount, error: any) => {
        // Don't retry on 401 errors (handled by interceptor)
        if (error?.response?.status === 401 || error?.code === 401) {
          return false;
        }
        // A file held by the antivirus scan won't clear within the retry window,
        // and each retry would toast the same 409 again.
        if (error?.scanHeld === true) {
          return false;
        }
        // Retry other errors up to 2 times
        return failureCount < 2;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      // Don't retry mutations by default (manual retry via UI is better)
      retry: false,
    },
  },
});

export { reactQueryClient };
